import { number, object, string } from 'prop-types';
import React from 'react';
import DebugBundle from 'components/DebugBundle';

// handles mapping the layout to front-end bundle types and variants
// [0] is bundle type
// [1] is bundle variant
const LAYOUT_MAP = {
  interrupter: ['item', null],
  post: ['post', null],
  standalone: ['standalone', null],
  widescreenGrid: ['spread', 'widescreenGrid'],
  // primarily teaser bundles available from Flow
  // roughly ordered in order of "generic"
  a: ['spread', 'grid'],
  b: ['spread', 'grid'],
  c: ['spread', 'expandedGrid'],
  d: ['spread', 'flood'],
  e: ['spread', 'grid'],
  f: ['spread', 'grid'],
  g: ['spread', 'spotlight'],
  h: ['spread', 'porthole'],
  i: ['spread', 'grid'],
  j: ['spread', 'grid'],
  k: ['spread', 'soundbar'],
  l: ['spread', 'minidisc'],
  m: ['spread', 'grid'],
  n: ['spread', 'threeGrid'],
  o: ['spread', 'threeExpandedGrid'],
  p: ['spread', 'column'],
  q: ['spread', 'grid'],
  r: ['spread', 'listWide'],
  s: ['spread', 'surroundSound'],
  t: ['spread', 'everyday'],
  u: ['spread', 'everydayGrid'],
  stream: ['spread', 'listWide'],
  // these names are deprecated. Putting this in to
  // keep them from showing the debug bundle
  grid: ['spread', 'grid'],
  expandedGrid: ['spread', 'grid'],
  flood: ['spread', 'grid'],
  mini: ['spread', 'grid'],
  topper: ['spread', 'grid'],
  spotlight: ['spread', 'grid'],
  porthole: ['spread', 'grid'],
  promotedAt: ['spread', 'grid'],
  mondrian: ['spread', 'grid'],
  soundbar: ['spread', 'grid'],
  minidisc: ['spread', 'grid']
};

const DEFAULT_COMPONENT = DebugBundle;

/**
 * ContentBundle is a component that, when passed props of a bundle, directs
 * the rendering of the bundle to the appropriate React component based on the
 * bundle type (derived from the`layout` prop). If it encounters an unknown
 * type, it renders the default component. All delegated components are wrapped
 * in a section.ContentBundle.
 */
function ContentBundle(props) {
  const { layout, idx, components } = props;

  // derive the type and variant props from the layout
  const type = LAYOUT_MAP[layout] ? LAYOUT_MAP[layout][0] : undefined;
  const variant = LAYOUT_MAP[layout] ? LAYOUT_MAP[layout][1] : undefined;

  // derive the actual component from the type, or get the default
  const BundleComponent = components[type] || DEFAULT_COMPONENT;

  // allows us to track which exact bundle is interacted with
  const gtmAttrs = {
    'data-gtm-bundle-layout': layout,
    'data-gtm-bundle-position': idx + 1
  };

  return (
    <section
      className={`ContentBundle ContentBundle--${type}${
        variant ? `-${variant}` : ''
      }`}
    >
      <BundleComponent
        {...props}
        type={type}
        variant={variant}
        gtmAttrs={gtmAttrs}
      />
    </section>
  );
}

// note that to be useful, bundles need more than just id and type. this
// component, however, does not utilize them so we don't define them here.
ContentBundle.propTypes = {
  id: string.isRequired,
  layout: string.isRequired,
  idx: number.isRequired,
  components: object.isRequired // eslint-disable-line react/forbid-prop-types
};

export default ContentBundle;
